import { useNickFetch } from "#app/hooks/useNickFetch";
import { useNotice } from "#app/hooks/useNotice";
import { useViewer } from "#app/hooks/useViewer";
import { Shop, ShopStatus } from "#app/models";
import { Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, Typography } from "@mui/material";
import { useState } from "react";
import NickDialog from "./NickDialog";

type Props = {
	shop: Shop,
	// 保存に成功した時に、更新後の店舗を渡す.
	onChange?: (shop: Shop) => void,
	size?: "small" | "medium",
}
type SaveShopStatusResponse = {
	shop: Shop,
}

/**
 * 店舗の有効/無効切り替えスイッチ.
 * マスター権限の時だけ表示される.
 */
export default function ShopStatusSwitch(props: Props) {
	const { shop, onChange, size = "small" } = props;
	const { viewer } = useViewer();
	const { nickFetch } = useNickFetch();
	const { addNotice } = useNotice();
	const [saving, setSaving] = useState(false);
	const [confirmOpen, setConfirmOpen] = useState(false);

	if ( !viewer.isMaster() ) return null;

	const save = async (status: ShopStatus) => {
		setSaving(true);
		const res = await nickFetch("/save_shop_status/", {
			shop_id: shop.id,
			status: status,
		});
		setSaving(false);
		if (!res.error) {
			const data = res.data as SaveShopStatusResponse;
			addNotice(status === ShopStatus.ALIVE ? "店舗を有効にしました" : "店舗を無効にしました", "success");
			if (onChange && data.shop) onChange(new Shop(data.shop));
		}
	}

	const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.checked) {
			save(ShopStatus.ALIVE);
		} else {
			// 無効にする時は確認する.
			setConfirmOpen(true);
		}
	}

	return (
		<>
			<FormControlLabel
				control={<Switch size={size} checked={shop.isAlive()} onChange={handleToggle} disabled={saving || !shop.id} />}
				label={<Typography variant="caption">{shop.isAlive() ? "有効" : "無効"}</Typography>}
				onClick={(e) => e.stopPropagation()}
			/>
			<NickDialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
				<DialogTitle>店舗を無効にしますか？</DialogTitle>
				<DialogContent>
					<Typography variant="body2">
						「{shop.title}」を無効にすると、Instagram・ホットペッパーからの同期とGoogleへの投稿が停止し、一般ユーザーの店舗一覧に表示されなくなります。
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setConfirmOpen(false)}>キャンセル</Button>
					<Button color="error" variant="contained" onClick={() => { setConfirmOpen(false); save(ShopStatus.NONE); }}>無効にする</Button>
				</DialogActions>
			</NickDialog>
		</>
	);
}
